import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function JetMediaShuttleWorkflowReceiving() {
    return (
        <React.Fragment>
            <p>
                Media Shuttle and Jet can be integrated to receive content from Media Shuttle portal members and
                transfer uploaded content to another storage location using Jet. When content is uploaded to a Media
                Shuttle portal, it is added to a source directory for a Jet job, which starts based on its{' '}
                <a href="/jet/jobs/job-trigger-types">trigger type</a>.
            </p>
            <p>A Media Shuttle to Jet receiving workflow includes:</p>
            <ul>
                <li>
                    A Share or Submit portal with a storage path that points to the same location as the source endpoint
                    for the Jet job
                </li>
                <li>
                    A Jet job that has its destination endpoint on the company's internal network, and its source
                    endpoint in the perimeter network
                </li>
            </ul>
            <p>
                By transferring files through a common location, typically in a perimeter network, submitted content can
                move directly into a Jet workflow that transfers to a secure server within a corporate network, or by
                using a <a href="/jet/jobs/partner-jobs">partner job</a> to send content to another organization.
            </p>
        </React.Fragment>
    );
}

JetMediaShuttleWorkflowReceiving.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(JetMediaShuttleWorkflowReceiving);
